<template>
    <v-container style="max-width: 95%;">
        <v-row justify="center" align="center">
            <v-col cols="12" class="text-center">
                <h3 class="text--white80 pt-6">EVENT LOG</h3>
            </v-col>
        </v-row>
        <v-timeline v-if="logItems && userSettings"
                    dense
                    :class="{ 'transparent-line': logItems.length <= 1 }"
                    clipped>
            <v-timeline-item v-for="item in logItems"
                             :key="item.id"
                             color="white"
                             large>
                <template v-slot:icon>
                    <v-avatar>
                        <img src="@/assets/icons/unlock.svg" v-if="item.latestEventName.indexOf('Armed') !== -1" />
                        <img src="@/assets/icons/lock.svg" v-else-if="item.latestEventName.indexOf('Disarmed') !== -1" />
                        <img src="@/assets/icons/siren-red.svg" v-else-if="item.latestEventName.startsWith('Alarm')" />
                        <img src="@/assets/icons/tamper-triggered.svg" v-else-if="item.latestEventName.indexOf('Alarm - Tamper triggered') !== -1" />
                        <img src="@/assets/icons/immobilizer-off.svg" v-else-if="item.latestEventName.indexOf('Manual immobilizer off') !== -1" />
                        <img src="@/assets/icons/power-loss.svg" v-else-if="item.latestEventName.indexOf('Main power loss') !== -1" />
                        <img src="@/assets/icons/power-restore.svg" v-else-if="item.latestEventName.indexOf('Main power restored') !== -1" />
                        <img src="@/assets/icons/main-batt-low.svg" v-else-if="item.latestEventName.indexOf('Main battery low') !== -1" />
                        <img src="@/assets/icons/main-batt-ok.svg" v-else-if="item.latestEventName.indexOf('Main battery OK') !== -1" />
                        <img src="@/assets/icons/backup-batt-low.svg" v-else-if="item.latestEventName.indexOf('Backup battery low') !== -1" />
                        <img src="@/assets/icons/backup-batt-ok.svg" v-else-if="item.latestEventName.indexOf('Backup battery OK') !== -1" />
                        <img src="@/assets/icons/restarted.svg" v-else-if="item.latestEventName.indexOf('Restarted') !== -1" />
                        <img src="@/assets/icons/factory-reset.svg" v-else-if="item.latestEventName.indexOf('Factory reset') !== -1" />
                        <img src="@/assets/icons/geo-fence-breached.svg" v-else-if="item.latestEventName.indexOf('Geofence breach') !== -1" />
                        <img src="@/assets/icons/online.svg" v-else-if="item.latestEventName.indexOf('Online') !== -1" />
                        <img src="@/assets/icons/offline.svg" v-else-if="item.latestEventName.indexOf('Offline') !== -1" />
                        <img src="@/assets/icons/unknown-error.svg" v-else-if="item.latestEventName.indexOf('Unknown event') !== -1" />
                        <img src="@/assets/icons/unknown-error.svg" v-else />
                    </v-avatar>
                </template>
                <v-row justify="space-between" align="center" pt-2>
                    <v-col v-if="item.latestEventName.indexOf('shore') !== -1" cols="5" class="white--text">Shore Power disabled</v-col>
                    <v-col v-else-if="item.latestEventName.indexOf('smart') !== -1" cols="5" class="white--text">Smart Plug disabled</v-col>
                    <v-col v-else cols="5" class="white--text">{{ item.latestEventName }}</v-col>
                    <v-col cols="7" class="text-right white--text pr-6">{{ formatModifiedDate(item.modifiedDate) }}</v-col>
                </v-row>
            </v-timeline-item>
        </v-timeline>
    </v-container>
</template>

<script lang="ts">
    import { defineComponent, ref, computed } from "vue";
    import useCoreHistory from "@/store/useCoreHistory";
    import moment from 'moment-timezone';
    import useUserSettings from "@/store/useUserSettings";
    import UserSettingsViewModel from "@/models/UserSettingsViewModel";

    export default defineComponent({
        setup(_, context) {
            const { getUserSettings } = useUserSettings();
            const userSettings = ref<UserSettingsViewModel>();
            getUserSettings().then((value: UserSettingsViewModel) => {
                userSettings.value = value;
            });

            const { logItems } = useCoreHistory();

            const timezone = computed(() => userSettings.value?.timezone || "UTC");

            const formatModifiedDate = (modifiedDate: string) => {
                return moment.utc(modifiedDate).tz(timezone.value).format("MMM DD, YYYY HH:mm:ss");
            };

            return {
                logItems,
                userSettings,
                timezone,
                formatModifiedDate
            };
        }
    });
</script>
<style lang="scss" scoped>
    .theme--light.v-timeline:before {
        background: white;
        top: 40px;
    }

    .theme--light.v-timeline-item {
        align-items: center;
    }

    .transparent-line::v-deep.v-timeline:before {
        background: transparent !important;
    }
</style>